// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1zCcA","icon":"SortAdornment_icon__2exqY","up":"SortAdornment_up__2dEtK","down":"SortAdornment_down__1VZE-","active":"SortAdornment_active__3lMk0"};